import { cloneElement, ReactElement } from 'react';

import { cn } from 'support/helpers/cn/cn';
import { Button } from 'components/Form/Button/Button';

type EmptyStateProps = {
  title: string;
  description?: string;
  ctaText?: string;
  ctaOnClick?: () => void;
  icon: ReactElement<{ className?: string }>;
};

export const EmptyState = ({ title, description, ctaText, ctaOnClick, icon }: EmptyStateProps) => {
  return (
    <div className="mt-14">
      <div className="mx-auto flex w-150 flex-col items-center justify-center gap-6 px-8 text-center">
        <EmptyStateIcon icon={icon} />
        <h3 className={cn('text-lg font-bold text-gray-900', description ? '' : 'mb-1')}>{title}</h3>
        {description ? <p className="text-sm text-gray-500">{description}</p> : null}
        <EmptyStateCTA ctaText={ctaText} ctaOnClick={ctaOnClick} className={description ? undefined : 'mt-10'} />
      </div>
    </div>
  );
};

const EmptyStateIcon = ({ icon }: { icon: EmptyStateProps['icon'] }) => {
  return <div className="rounded-full bg-procuros-grey p-5">{cloneElement(icon, { className: 'h-16 w-16' })}</div>;
};

const EmptyStateCTA = ({
  ctaText,
  ctaOnClick,
  className,
}: {
  ctaText: EmptyStateProps['ctaText'];
  ctaOnClick: EmptyStateProps['ctaOnClick'];
  className?: string;
}) => {
  return ctaText ? (
    <Button onClick={ctaOnClick} className={className} analyticsId="empty_state_cta">
      {ctaText}
    </Button>
  ) : null;
};
